import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import FaqsAccordion from '../components/FaqsAccordion';
import { Link } from 'react-router-dom';
import { fetchFaqs } from '../store/slices/faqsSlice'; 

const Faqs = ({ 
  faqs: propsFaqs, 
  maxFaqs = 5, 
  showViewAllLink = true, 
  title: propsTitle, 
  description: propsDescription, 
  className, 
  accordionVariant 
}) => {
  const dispatch = useDispatch();
  const selectorFaqs = useSelector((state) => state.faqs);
  const { data: faqsFromStore, status, currentPage, error } = selectorFaqs;
  
  // Use props if available, otherwise use data from Redux store
  const faqs = propsFaqs || faqsFromStore;
  const MAX_FAQS_TO_SHOW = maxFaqs;
  const showViewAll = showViewAllLink;

  // Only fetch if using Redux store and data isn't already loading/loaded
  useEffect(() => {
    if (!propsFaqs && status === 'idle') {
      dispatch(fetchFaqs(currentPage));
    }
  }, [dispatch, currentPage, status, propsFaqs]);

  if (status === 'loading' && !propsFaqs) {
    return (
      <div className="space-blog">
        <div className="row">
          <div className="col-md-5">
            <h2><Skeleton width="60%" height={30} /></h2>
            <p><Skeleton width="90%" height={20} count={3} /></p>
          </div>
          <div className="col-md-7">
            <div className="skeleton-accordion">
              {[...Array(MAX_FAQS_TO_SHOW)].map((_, index) => (
                <div key={index} style={{ marginBottom: '20px' }}>
                  <Skeleton width="80%" height={25} />
                  <Skeleton width="95%" height={15} style={{ marginTop: '10px' }} />
                  <Skeleton width="90%" height={15} style={{ marginTop: '5px' }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if ((propsFaqs || status === 'succeeded') && faqs?.faqs?.length > 0) {
    const displayedFaqs = faqs.faqs.slice(0, MAX_FAQS_TO_SHOW);
    const title = propsTitle || faqs.title;
    const description = propsDescription || faqs.description;

    return (
      <div className={`container space-blog ${className || ''}`}>
        <div className="row">
          <div className="col-md-5">
            <h2 className="grey500 mb-8">{title}</h2>
            <p className="body grey66 mt-16 mb-24">{description}</p>
            {showViewAll && (
              <Link to="/tous-faq" className="link-blue ">
                Voir toute la FAQ{' '}
                <img src="/images/arrow-right.svg" className="arrow ml-8" alt="Arrow" />
              </Link>
            )}
          </div>
          <div className="col-md-7 mt-xs-8">
            <FaqsAccordion 
              elements={displayedFaqs} 
              variant={accordionVariant}
            />
          </div>
        </div>
      </div>
    );
  }

  // Don't show error if using props (might be intentional empty state)
  if (propsFaqs) return null;

  return (
    <div className="container space-bloc">
      <p>
        {status === 'failed' 
          ? `Error loading FAQs: ${error?.message || 'Unknown error'}`
          : 'No FAQs available.'}
      </p>
    </div>
  );
};

export default Faqs;